angular.module('rjmNg.directives').directive "timeFilter", [
  "$timeout"
  "$document"
  ($timeout, $document) ->
    restrict: "E"
    templateUrl: "directive.timeFilter.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      timeRange: "="
      interval: "="
      metrics: "=?"
      onChange: "="
      onRestore: "="
      isDropdownOpen: "="
      isDisabled: "="
      intervalEnabled: "=?"
      showDefault: "="
    controller: [
      "timeRangeEnums"
      "dateService"
      "app"
      (
        timeRangeEnums
        dateService
        app
      ) ->

        view = @
        view.isEditTimeOptionDisabled = false

        DATE_DISPLAY_FORMAT = 'MMM D, YYYY'
        TIME_INTERVAL_VALUES = timeRangeEnums.TIME_INTERVAL_VALUES
        view.INTERVALS_TO_SHOW = [
          TIME_INTERVAL_VALUES.NONE,
          TIME_INTERVAL_VALUES.HOUR,
          TIME_INTERVAL_VALUES.DAY,
          TIME_INTERVAL_VALUES.WEEK,
          TIME_INTERVAL_VALUES.MONTH,
          TIME_INTERVAL_VALUES.QUARTER,
          TIME_INTERVAL_VALUES.YEAR
        ]

        view.toggleDropdown = () ->
          view.isDropdownOpen = !view.isDropdownOpen
        view.isEditTimeOptionDisabled = not app.hasFeatureFlag('EDIT_TIME_OPTION')

        view.checkIfMetricsHaveGaMetric = () ->
          view.isGaMetrics = if view.metrics? then (true in view.metrics.map((metric) -> metric.isGaMetric)) else false

        view.updateMainButtonText = () ->
          view.rangeString = dateService.getRangeString(view.timeRange, DATE_DISPLAY_FORMAT, false)
          view.intervalString = if not view.interval? or view.interval is TIME_INTERVAL_VALUES.NONE then "" else " by #{view.interval}"
          if view.rangeString is "" and view.intervalString isnt ""
            view.mainButtonText = "Default Time Ranges" + view.intervalString
          else
            view.mainButtonText = view.rangeString + view.intervalString

        view.closeDropdown = () ->
          view.isDropdownOpen = false

        view.apply = () ->
          view.timeRange = view.outputTimeRange
          view.interval = view.outputInterval
          if view.timeRange is null and view.interval is null
            _invokeHandler(view.onRestore)
          else
            _invokeHandler(view.onChange)
          view.updateMainButtonText()
          view.closeDropdown()

        view.cancel = () ->
          view.closeDropdown()

        view.restoreTimeInterval = () ->
          view.outputInterval = null

        view.restoreDefaults = () ->
          view.timeRange = null
          view.interval = null
          _invokeHandler(view.onRestore)
          view.updateMainButtonText()
          view.closeDropdown()

        _invokeHandler = (handler) ->
          if handler?
            handler(view.timeRange, view.interval)

        view.$onInit = () ->
          view.intervalEnabled ?= true
          view.updateMainButtonText()
          view.checkIfMetricsHaveGaMetric()

        view

    ]
    link: (scope, elem, attrs, view) ->
      # Click outside for closing
      $document.on("click", (event) ->
        $trigger = $(".time-filter")
        if $trigger isnt event.target and not $trigger.has(event.target).length
          $timeout(() -> view.closeDropdown())
      )

      if view.metrics?
        scope.$watch('view.metrics.length', (newMetricsLength, oldMetricsLength) ->
          if newMetricsLength isnt oldMetricsLength
            view.checkIfMetricsHaveGaMetric()
        )

      scope.$watch 'view.timeRange', view.updateMainButtonText, true
      scope.$watch 'view.interval', view.updateMainButtonText, true
]
